import { Tag } from '@grupoboticario/flora-react';
import styled from 'styled-components';

export const StatusTag = styled(Tag)`
  height: 16px;
  padding: 0 12px;

  line-height: 16px;
  min-height: 16px;

  border: none;

  font-weight: 500;
`;

type ColorProps = {
  color?: string;
};

export const DaysTag = styled(Tag)<ColorProps>`
  height: 16px;
  padding: 0 12px;

  line-height: 16px;
  min-height: 16px;

  font-weight: 500;

  color: ${({ color }) => color};
  border-color: ${({ color }) => color};
`;
